import { FC, ReactNode, useRef } from 'react';

import Tab from '../../atoms/Tab';

import styles from './TabNavigation.module.scss';

const SCROLL_OFFSET_PADDING = 16;

const getArrowDirection = (index: number, selectedTab: number) =>
  selectedTab === index ? 'asc' : 'desc';

interface Props {
  controlledSelection?: number;
  list: Array<{
    content?: ReactNode;
    label?: string;
    showArrow?: boolean;
  }>;
  onTabClick: (index: number) => void;
}

const TabNavigation: FC<Props> = ({ controlledSelection = 0, list, onTabClick }) => {
  const tabNavigationRef = useRef<HTMLDivElement>(null);

  return (
    <div className={styles['z-tab-navigation']}>
      <div className={styles['z-tab-navigation-list']} ref={tabNavigationRef}>
        {list.map(({ label, showArrow }, index) => (
          <Tab
            direction={showArrow ? getArrowDirection(index, controlledSelection) : undefined}
            key={label}
            label={label}
            // eslint-disable-next-line react/jsx-no-bind
            onClick={(offsetLeft) => {
              tabNavigationRef.current?.scrollTo({
                behavior: 'smooth',
                left: (offsetLeft ?? 0) - SCROLL_OFFSET_PADDING,
                top: 0,
              });
              onTabClick(index);
            }}
            selected={controlledSelection === index}
          />
        ))}
      </div>
      <hr className={styles['z-tab-navigation-border']} />
      {list[controlledSelection]?.content}
    </div>
  );
};

export default TabNavigation;
export type { Props as TabNavigationProps };
